import { APIClient } from "api/api_helper";
import { POST_STUDY_ASSESSMENT_API, VITAL_SIGN_MEASUREMENT_API, LABORATORY_ASSESSMENT_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const postStudyAssessmentApiService = {
  // -----------------------------
  // INSERT VITAL SIGNS
  // -----------------------------
  insertVitalSigns: (payload_data: {
    studyid: number;
    subjectno: string | number;
    assessmentdate: string;
    position: string;
    actualtime: string;
    bloodpressure: string;
    pulserate: number;
    respirationrate: number;
    oraltemperature: number;
    wellbeingassessment: string;
    respiratorysystem: string;
    gastrointestinalsystem: string;
    cardiovascularsystem: string;
    centralnervoussystem: string;
    participantstatus: string;
    remarks?: string | null;
  }) => {
    const user = GetUserData() as CurrentUser;

    const payload = {
      ...payload_data,
      createdby: user.userid,
    };

    return api.create(
      VITAL_SIGN_MEASUREMENT_API.VITAL_SIGN_MEASUREMENT_API + "Insert",
      payload
    );
  },

  // -----------------------------
  // UPDATE VITAL SIGNS
  // -----------------------------
  updateVitalSigns: (payload_data: {
    poststudyassessmentid: number;
    assessmentdate: string;
    position: string;
    actualtime: string;
    bloodpressure: string;
    pulserate: number;
    respirationrate: number;
    oraltemperature: number;
    wellbeingassessment: string;
    respiratorysystem: string;
    gastrointestinalsystem: string;
    cardiovascularsystem: string;
    centralnervoussystem: string;
    participantstatus: string;
    updatereason: string;
    remarks?: string | null;
  }) => {
    const user = GetUserData() as CurrentUser;

    const payload = {
      ...payload_data,
      updatedby: user.userid,
    };

    return api.create(
      VITAL_SIGN_MEASUREMENT_API.VITAL_SIGN_MEASUREMENT_API + "Update",
      payload
    );
  },

  // -----------------------------
  // SELECT ASSESSMENT
  // -----------------------------
  selectAssessment: (studyid: number, subjectno: string | number) => {
    const payload = {
      studyid,
      subjectno
    };
    return api.create(
      POST_STUDY_ASSESSMENT_API.POST_STUDY_ASSESSMENT_API + "Select",
      payload
    );
  },

  // -----------------------------
  // INSERT LABORATORY ASSESSMENT
  // -----------------------------
  insertLab: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const finalPayload = {
      ...payload,
      createdby: user.userid,
      updatedby: user.userid,
    };
    return api.create(
      LABORATORY_ASSESSMENT_API.LABORATORY_ASSESSMENT_API + "Insert",
      finalPayload
    );
  },

  // -----------------------------
  // UPDATE LABORATORY ASSESSMENT
  // -----------------------------
  updateLab: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const finalPayload = {
      ...payload,
      updatedby: user.userid,
    };
    return api.create(
      LABORATORY_ASSESSMENT_API.LABORATORY_ASSESSMENT_API + "Update",
      finalPayload
    );
  },

  // -----------------------------
  // VERIFY ASSESSMENT
  // -----------------------------
  verifyAssessment: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    return api.create(
      POST_STUDY_ASSESSMENT_API.POST_STUDY_ASSESSMENT_API + "Verify",
      {
        ...payload,
        verifiedby: user.userid
      }
    );
  },
};
